import "@fontsource-variable/instrument-sans/wght.css";
import "@fontsource-variable/jetbrains-mono/wght.css";
import { initializationFailureCopy } from "@/i18n/boot";
import { redirectLegacyOrigin } from "@/legacyOrigin";
import "./styles/app.css";

function renderInitializationFailure(): void {
  const root = document.getElementById("root");
  if (root) {
    const copyText = initializationFailureCopy(window.location.pathname);
    root.replaceChildren();
    const main = document.createElement("main");
    main.className = "boot-status";
    main.setAttribute("role", "alert");
    const heading = document.createElement("h1");
    heading.textContent = copyText.heading;
    const copy = document.createElement("p");
    copy.textContent = copyText.detail;
    main.append(heading, copy);
    root.append(main);
  }
  // The error object may include local configuration, so it is intentionally not logged.
}

try {
  if (!redirectLegacyOrigin(window.location, (target) => window.location.replace(target))) {
    void import("@/bootstrap").then(({ mountApplication }) => mountApplication()).catch(() => {
      renderInitializationFailure();
    });
  }
} catch {
  renderInitializationFailure();
}
